import React, { useState, useEffect } from "react";
import Header from "./header/header";
import Footer from "./Footer";
import "./Handsonexperience.css";
import { useNavigate } from "react-router-dom";
import Typewriter from "react-ts-typewriter";
import { ClipLoader } from "react-spinners";

const Handsonexperience: React.FC = () => {
  const [ready, setReady] = useState(false);
  let navigate = useNavigate();

  var typess: any = [
    "Software  Developer",
    "Data Analyst",
    "Software Engineer",
    "Product Designer",
  ];

  const tohandsform = () => {
    navigate("/handsonform");
  };
  const scrolltoAdmission = () => {
    var element: any = document.getElementById("admissionsec");
    element.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
  };

  const scrolltoProject = () => {
    var toProject: any = document.getElementById("projectsec");
    toProject.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
  };

  const scrolltoProjectReview = () => {
    var toProjectReview: any = document.getElementById("projectreviewsec");
    toProjectReview.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
  };

  const scrolltoPeertopeer = () => {
    var toPeertopeer: any = document.getElementById("peertopeersec");
    toPeertopeer.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
  };

  const scrolltoCareer = () => {
    var toCareer: any = document.getElementById("careersec");
    toCareer.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
  };

  useEffect(() => {
    new Promise((r) => setTimeout(r, 205));
    setReady(true);
  }, []);

  return (
    <div style={{ overflowX: "hidden" }}>
      {ready ? (
        <>
          <Header />
          <div style={{ zIndex: "100", marginTop:"-40px" }}>
            <div className="headmid"></div>

            <div>
              <div>
                <div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="setCenter">
                        <h3 className="firstherotext">
                          Join a Team as a{" "}
                          <span style={{ color: "#165215" }}>
                            <Typewriter
                              text={typess}
                              speed={210}
                              loop={true}
                              delay={410}
                            />
                          </span>
                        </h3>
                        <p className="secondherotext">
                          Discover our engaging 'Hands-On Experience' service,
                          where participants learn and explore through active
                          participation, gaining practical skills and knowledge
                          in an immersive and interactive environment
                        </p>

                        <button className="handsonbtn" onClick={tohandsform}>
                          Join the Programme
                        </button>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="banimgpadsize">
                        <img
                          src="../../images/handsonexperience.png"
                          style={{
                            width: "100%",
                            marginTop: "70px",
                            height: "400px",
                            marginBottom: "30px",
                          }}
                          alt="heroim"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container" style={{ marginTop: "100px" }}>
            <div>
              <div className="text-center">
                <h4
                  style={{
                    fontSize: "32px",
                    fontWeight: "600",
                    paddingTop: "17px",
                    paddingBottom: "17px",
                  }}
                >
                  Our Mentors also work at
                </h4>
              </div>

              <div className=" movementicon">
                <div className="achcompany">
                  <div className="container">
                    <div className="row ">
                      <div className="col">
                        <img
                          src="../../images/Microsoft.png"
                          className="companyi"
                          alt="microsoft"
                        />
                      </div>
                      <div className="col">
                        <img
                          src="../../images/Telsa.png"
                          className="companyi"
                          alt="telsa"
                        />
                      </div>
                      <div className="col">
                        <img
                          src="../../images/roter.png"
                          className="companyi"
                          alt="microsoft"
                        />
                      </div>
                      <div className="col">
                        <img
                          src="../../images/Netflix.png"
                          className="companyi"
                          alt="microsoft"
                        />
                      </div>
                      <div className="col">
                        <img
                          src="../../images/Wise.png"
                          className="companyi"
                          alt="microsoft"
                        />
                      </div>
                      <div className="col">
                        <img
                          src="../../images/Amazon.png"
                          className="companyi"
                          alt="microsoft"
                        />
                      </div>
                      <div className="col">
                        <img
                          src="../../images/Apple.png"
                          className="companyi"
                          alt="microsoft"
                        />
                      </div>
                      <div className="col">
                        <img
                          src="../../images/Google.png"
                          className="companyi"
                          alt="microsoft"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container" style={{ marginTop: "100px" }}>
            <div className="row">
              <div className="col-md-5">
                <div className="accelerateTech">
                  <img
                    src="../../images/handsondetails.png"
                    style={{
                      position: "absolute",
                      bottom: "30px",
                      left: "30px",
                      width: "100%",
                    }}
                    alt="handsondetails"
                  />
                </div>
              </div>
              <div className="col-md-7">
                <div className="container">
                  <div style={{ marginLeft: "25px" }}>
                    <h4>Accelerate Your Tech Career</h4>
                    <p style={{ fontSize: "19px" }}>
                      Are you ready to supercharge your tech career? Look no
                      further than our cutting-edge Tech Career Accelerator
                      Service. We believe that hands-on experience is the key to
                      unlocking your full potential in the tech industry. Our
                      expert team is dedicated to helping you gain practical
                      expertise in your chosen field, be it coding,
                      cybersecurity, data analysis, or more. Through a tailored
                      curriculum of immersive projects and real-world scenarios,
                      you'll not only deepen your knowledge but also develop
                      crucial problem-solving skills that will set you apart
                      from the competition.
                    </p>
                    <p style={{ marginTop: "20px", fontSize: "19px" }}>
                      Our service goes beyond just learning; it's about
                      transforming theory into tangible skills and
                      accomplishments. With a strong portfolio of work, you'll
                      become a sought-after candidate for top tech jobs and
                      enjoy accelerated career growth. Don't wait—join our Tech
                      Career Accelerator Service today and accelerate your
                      journey to success in the dynamic world of technology!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container text-center" style={{ marginTop: "100px" }}>
            <h2>How It works</h2>
            <p style={{ marginTop: "20px", fontSize: "19px" }}>
              Our service goes beyond just learning; it's about transforming
              theory into tangible skills and accomplishments. With a strong
              portfolio of work, you'll become a sought-after candidate for top
              tech jobs and enjoy accelerated career growth. Don't wait—join our
              Tech Career Accelerator Service today and accelerate your journey
              to success in the dynamic world of technology
            </p>
          </div>

          <div className="container text-center" style={{ marginTop: "40px" }}>
            <div className="row">
              <div className="col-md-3">
                <h5 className="addmiss" onClick={scrolltoAdmission}>
                  Admissions
                </h5>
                <h5 className="otherhowwork" onClick={scrolltoPeertopeer}>
                  Learning
                </h5>
                <h5 className="otherhowwork" onClick={scrolltoProject}>
                  Projects
                </h5>
                <h5 className="otherhowwork" onClick={scrolltoProjectReview}>
                  Project Review
                </h5>
                <h5 className="otherhowwork" onClick={scrolltoCareer}>
                  Career
                </h5>
              </div>
              <div className="col-md-9">
                <img
                  src="../../images/handsondiagram.png"
                  className="handsondia"
                  alt="handsondiagram"
                />
              </div>
            </div>
          </div>

          <div
            className="container"
            id="admissionsec"
            style={{ marginTop: "170px" }}
          >
            <div className="row">
              <div className="col-md-7">
                <div className="container">
                  <div style={{ marginLeft: "25px", marginTop: "45px" }}>
                    <h2>Admission</h2>
                    <p style={{ fontSize: "19px", marginBottom: "50px" }}>
                      Admission to our hands-on experience website is a straight
                      forward journey. Simply register with your credentials,
                      and you're in! We believe in inclusivity and
                      accessibility, so our admission process is open to all
                      eager learners, regardless of background or experience.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="handssadmission">
                  <img
                    src="../../images/admission.png"
                    style={{
                      position: "absolute",
                      bottom: "30px",
                      left: "30px",
                      width: "100%",
                    }}
                    alt="handsondetails"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            className="container"
            id="peertopeersec"
            style={{ marginTop: "140px" }}
          >
            <div className="row">
              <div className="col-md-5">
                <div className="handpeertopeer">
                  <img
                    src="../../images/peertopeer.png"
                    style={{
                      position: "absolute",
                      bottom: "30px",
                      left: "30px",
                      width: "100%",
                    }}
                    alt="handsondetails"
                  />
                </div>
              </div>
              <div className="col-md-7">
                <div className="container">
                  <div
                    className="container"
                    style={{ marginTop: "45px", marginLeft: "25px" }}
                  >
                    <h2>Peer to Peer Learning</h2>
                    <p style={{ fontSize: "19px" }}>
                      Once you're in, you'll embark on an exciting learning
                      adventure. Our platform offers a curated selection of
                      courses and resources to help you gain practical skills in
                      various domains. You'll have access to engaging lessons,
                      interactive quizzes, and a supportive community to guide
                      you through your learning journey. Whether you're a
                      beginner or an experienced professional, there's always
                      something new to discover.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="container"
            id="projectsec"
            style={{ marginTop: "100px" }}
          >
            <div className="row">
              <div className="col-md-7">
                <div className="container">
                  <div style={{ marginLeft: "25px", marginTop: "45px" }}>
                    <h2>Projects </h2>
                    <p style={{ fontSize: "19px", marginBottom: "50px" }}>
                      Putting theory into practice is crucial, and that's where
                      the project phase comes in. You'll have the opportunity to
                      choose from a range of real-world projects that align with
                      your interests and goals. These hands-on projects are
                      designed to challenge and inspire you, allowing you to
                      apply your newfound knowledge in a practical context.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="handsproreview">
                  <img
                    src="../../images/handproject.png"
                    style={{
                      position: "absolute",
                      bottom: "30px",
                      left: "30px",
                      width: "100%",
                    }}
                    alt="handsondetails"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            className="container"
            id="projectreviewsec"
            style={{ marginTop: "140px" }}
          >
            <div className="row">
              <div className="col-md-5">
                <div className="projectreeeview">
                  <img
                    src="../../images/projectreview.png"
                    style={{
                      position: "absolute",
                      bottom: "30px",
                      left: "30px",
                      width: "100%",
                    }}
                    alt="handsondetails"
                  />
                </div>
              </div>
              <div className="col-md-7">
                <div className="container">
                  <div
                    className="container"
                    style={{ marginTop: "45px", marginLeft: "25px" }}
                  >
                    <h2>Project Reviews</h2>
                    <p style={{ fontSize: "19px" }}>
                      Feedback is the cornerstone of growth. During the project
                      phase, you'll receive constructive feedback from
                      experienced mentors and peers. We believe in a
                      collaborative learning environment, where reviews help you
                      refine your skills and build confidence in your abilities.
                      It's a chance to fine-tune your work and learn from others
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="container"
            id="careersec"
            style={{ marginTop: "100px" }}
          >
            <div className="row">
              <div className="col-md-7">
                <div className="container">
                  <div style={{ marginLeft: "25px", marginTop: "45px" }}>
                    <h2>Career </h2>
                    <p style={{ fontSize: "19px", marginBottom: "80px" }}>
                      Our ultimate goal is to empower you for success in your
                      career. Upon completing your projects and courses, you'll
                      receive a certification that you can proudly showcase on
                      your resume and LinkedIn profile. We also provide
                      resources to help you with job placement and career
                      guidance, connecting you with potential employers or
                      freelance opportunities in your chosen field. Your journey
                      with us doesn't end at graduation; it's a stepping stone
                      toward a bright future in your desired career path.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="handsproreview">
                  <img
                    src="../../images/carreer.png"
                    style={{
                      position: "absolute",
                      bottom: "30px",
                      left: "30px",
                      width: "100%",
                    }}
                    alt="handsondetails"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="container" style={{ marginTop: "100px" }}>
            <div className="text-center">
              <h3 style={{ fontSize: "24px", marginBottom: "20px" }}>
                Steps to Join Hands-on Experience Programme
              </h3>
            </div>

            <div style={{ marginTop: "20px" }}>
              <div className="row">
                <div className="col-md-6 text-center">
                  <div
                    style={{
                      marginLeft: "39%",
                      height: "108px",
                      width: "108px",
                      borderRadius: "78px",
                      backgroundColor: "#B0FFC1",
                    }}
                  >
                    <img
                      style={{ marginTop: "10%" }}
                      src="../../images/verify.png"
                      alt="verify"
                    />
                  </div>

                  <h4 style={{ marginTop: "18px" }}>Register</h4>
                </div>

                <div className="col-md-6 text-center">
                  <div
                    style={{
                      marginLeft: "39%",
                      height: "108px",
                      width: "108px",
                      borderRadius: "78px",
                      backgroundColor: "#B0FFC1",
                    }}
                  >
                    <img
                      style={{ marginTop: "10%" }}
                      src="../../images/payment.png"
                      alt="payment"
                    />
                  </div>

                  <h4 style={{ marginTop: "18px" }}>Payment</h4>
                </div>
              </div>
            </div>
          </div>

          <br />
          <br />
          <br />

          <Footer />
        </>
      ) : (
        <>
          <div>
            <div className="academystyle">
              <img src="../../images/doyenifyAcademy.png" alt="doy academy" />
              <ClipLoader size={25} color="#047E35" />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Handsonexperience;
